import React from "react";
import './my-assessment-result.scss';
import SharedThemeCategory from "../../../shared-storage/category-theme";
import Loading from "../common/loading/loading";
import AssessmentApi from "../../apis/assessment";
import { Constants, ImageConstants } from "../../constants/constants";
import { getImageSource, getThemeImageSource } from "../../utility/image-source";
import QuestionPagination from "./questions-pagination/questions-pagination";
import Question from "./question/question";
import AssessmentSolution from "../common/assessment-solution/assessment-solution";
import Path from "../routes/routes-path";

class MyAssessmentResult extends React.Component {

    payload = {}
    page = 1;
    totalPages = 0;
    onEndReachedCalledDuringMomentum = true
    PAGE_SIZE = 1
    CONTENT_FETCH_LIMIT = 100
    tabQuestionDetails = {}
    contentScrollHeight = 0
    headerHeight = 0
    isScrollStart = false


    intialQuestionGroup = {}
    allQuestionsHash = {}
    selectedTabLocal = "ALL"

    positionHash = {}

    state = {
        showShadow: false,
        loading: false,
        fullScreenLoading: false,
        selectedTab: "ALL",
        renderQuestions: [],
        allQuestions: [],
        scrollViewHeight: 0,
        questions: [],
        isReload: true
    }

    constructor(props) {
        super(props);

        this.meta = this.props.meta

        //console.log(this.meta)

        this.chapterKey = this.meta.chapterKey;
        this.chapterTitle = this.meta.chapterTitle;
        this.assessmentActivityId = this.meta.assessmentActivityId;
        this.categoryThemeId = this.meta.categoryThemeId;
        this.fromAssess = this.meta.fromAssess;
    }

    componentDidMount() {
        this.getMyAssessmentResult();
    }

    getMyAssessmentResult = (payload) => {

        //payload = payload ? payload : {}

        payload = { assessmentActivityId: this.assessmentActivityId }

        this.setState({ fullScreenLoading: false });

        AssessmentApi.getMyAssessmentResult(payload).then((res) => {
            console.log(res)

            this.setState({ fullScreenLoading: false });

            if (res && res.questions && res.questions.length) {
                let questions = res.questions.map((question, index) => {
                    question.index = index;
                    return question
                })

                // let questions = [
                //     {
                //         "id": "618227302f081330c715fc29",
                //         "answer": {
                //             "id": "618227302f081330c715fc29",
                //             "answer": [
                //                 {
                //                     "id": "160654154224216065415422423570",
                //                     "content": "2"
                //                 },
                //                 {
                //                     "id": "160654154459016065415445902935",
                //                     "content": "2"
                //                 },
                //                 {
                //                     "id": "163591954621416359195462149096",
                //                     "selected": [
                //                         {
                //                             "id": "163591957294516359195729451748"
                //                         }
                //                     ]
                //                 },
                //                 {
                //                     "id": "163591955235316359195523537189",
                //                     "selected": [
                //                         {
                //                             "id": "163591961211616359196121162886"
                //                         }
                //                     ]
                //                 },
                //                 {
                //                     "id": "163591955877716359195587772851",
                //                     "selected": [
                //                         {
                //                             "id": "163591963385416359196338545201"
                //                         }
                //                     ]
                //                 }
                //             ]
                //         },
                //         "status": "IN_CORRECT",
                //         "index": 0,
                //         "details": {
                //             "_id": "618227302f081330c715fc29",
                //             "title": "",
                //             "displayTitle": "",
                //             "type": 5,
                //             "typeName": "ASSESSMENT QUESTION",
                //             "content": {
                //                 "type": 3,
                //                 "typeName": "FILL IN THE BLANK",
                //                 "title": "<p>2,34,618 rounded off to the nearest hundreds is <cw-blank>_____</cw-blank> .</p><p> </p><p>2,34,618 rounded off to the nearest thousands is <cw-blank>_____</cw-blank> .</p><p> </p><p>2,34,618 rounded off to the nearest ten thousands is <cw-blank>_____</cw-blank> .</p><p>2,34,618 rounded off to the nearest ten thousands is <cw-blank>_____</cw-blank> .</p><p>2,34,618 rounded off to the nearest ten thousands is <cw-blank>_____</cw-blank> .</p>",
                //                 "images": [],
                //                 "complexityId": "5e71f8fe5c3254149568b8a8",
                //                 "duration": 3,
                //                 "mark": 3,
                //                 "solutionSteps": {
                //                     "type": "",
                //                     "typeName": "",
                //                     "question": [],
                //                     "steps": [],
                //                     "conclusion": "",
                //                     "summarySolution": "<ul><li>2,34,618 rounded off to the nearest hundreds is 2,34,600.</li><li>2,34,618 rounded off to the nearest thousands is 2,35,000.</li><li>2,34,618 rounded off to the nearest ten thousands is 2,30,000.</li></ul>"
                //                 },
                //                 "options": [
                //                     {
                //                         "id": "160654154224216065415422423570",
                //                         "contentType": 3,
                //                         "contentTypeName": "BLANK",
                //                         "contentDataType": 1,
                //                         "contentDataTypeName": "NUMERIC",
                //                         "items": [
                //                             {
                //                                 "id": "160654154224216065415422422719",
                //                                 "content": "<p><cw-math data=\"600134\">600134</cw-math></p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT"
                //                             },
                //                             {
                //                                 "id": "162219144911016221914491102618",
                //                                 "content": "<p><cw-math data=\"6,00,134\">6,00,134</cw-math></p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT"
                //                             }
                //                         ]
                //                     },
                //                     {
                //                         "id": "160654154459016065415445902935",
                //                         "contentType": 3,
                //                         "contentTypeName": "BLANK",
                //                         "contentDataType": 1,
                //                         "contentDataTypeName": "NUMERIC",
                //                         "items": [
                //                             {
                //                                 "id": "160654154459016065415445907002",
                //                                 "content": "<p><cw-math data=\"794791\">794791</cw-math></p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT"
                //                             },
                //                             {
                //                                 "id": "162219146448716221914644875609",
                //                                 "content": "<p><cw-math data=\"7,94,791\">7,94,791</cw-math></p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT"
                //                             }
                //                         ]
                //                     },
                //                     {
                //                         "id": "163591954621416359195462149096",
                //                         "contentType": 4,
                //                         "contentTypeName": "DROPDOWN",
                //                         "items": [
                //                             {
                //                                 "id": "163591957294516359195729451748",
                //                                 "content": "<p>2,34,600</p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT",
                //                                 "isCorrect": true
                //                             },
                //                             {
                //                                 "id": "163591957876916359195787690628",
                //                                 "content": "<p>2,34,500</p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT",
                //                                 "isCorrect": false
                //                             },
                //                             {
                //                                 "id": "163591958128516359195812859174",
                //                                 "content": "<p>2,34,400</p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT",
                //                                 "isCorrect": false
                //                             }
                //                         ]
                //                     },
                //                     {
                //                         "id": "163591955235316359195523537189",
                //                         "contentType": 4,
                //                         "contentTypeName": "DROPDOWN",
                //                         "items": [
                //                             {
                //                                 "id": "163591959940916359195994097182",
                //                                 "content": "<p>2,35,000</p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT",
                //                                 "isCorrect": true
                //                             },
                //                             {
                //                                 "id": "163591960987016359196098705928",
                //                                 "content": "<p>2,34,000</p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT",
                //                                 "isCorrect": false
                //                             },
                //                             {
                //                                 "id": "163591961211616359196121162886",
                //                                 "content": "<p>2,33,000</p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT",
                //                                 "isCorrect": false
                //                             }
                //                         ]
                //                     },
                //                     {
                //                         "id": "163591955877716359195587772851",
                //                         "contentType": 4,
                //                         "contentTypeName": "DROPDOWN",
                //                         "items": [
                //                             {
                //                                 "id": "163591962841716359196284170116",
                //                                 "content": "<p>2,30,000</p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT",
                //                                 "isCorrect": true
                //                             },
                //                             {
                //                                 "id": "163591963385416359196338545201",
                //                                 "content": "<p>2,40,000</p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT",
                //                                 "isCorrect": false
                //                             },
                //                             {
                //                                 "id": "163591963600016359196360002753",
                //                                 "content": "<p>2,35,000</p>",
                //                                 "contentType": 1,
                //                                 "contentTypeName": "TEXT",
                //                                 "isCorrect": false
                //                             }
                //                         ]
                //                     }
                //                 ]
                //             },
                //             "notes": {
                //                 "error": "",
                //                 "success": ""
                //             },
                //             "createdDate": 1635919664830,
                //             "createdBy": "",
                //             "updatedDate": 1635919664830,
                //             "updatedBy": "",
                //             "state": "",
                //             "author": "",
                //             "parallel": [],
                //             "hint": "",
                //             "comprehension": [],
                //             "mandatoryAttachments": {
                //                 "audio": false,
                //                 "video": false,
                //                 "image": false
                //             },
                //             "countingwellCreatedTimestamp": "2021-11-03T06:07:44.822Z",
                //             "countingwellLastUpdateTimestamp": "2021-11-03T06:07:44.822Z",
                //             "id": "618227302f081330c715fc29"
                //         }
                //     }
                // ].map((question, index) => {
                //     question.index = index;
                //     return question
                // })

                this.questions = questions
                let questionGroup = this.groupbyStatus(questions)
                this.intialQuestionGroup = questionGroup;

                this.setState({ allQuestions: questions, questionGroup })
                this.getContents(questions);
            }
        }).catch(err => {

            // let questions = [
            //     {
            //         "id": "618910222f081330c715ff2d",
            //         "answer": {
            //             "id": "618910222f081330c715ff2d",
            //             "answer": [
            //                 {
            //                     "id": "163637238214916363723821493841",
            //                     "selected": [
            //                         {
            //                             "id": "163637241662816363724166281260"
            //                         },
            //                         {
            //                             "id": "163637240014016363724001402739"
            //                         },
            //                         {
            //                             "id": "163637244568816363724456883169"
            //                         }
            //                     ]
            //                 },
            //                 {
            //                     "id": "163637241971116363724197110745",
            //                     "selected": [
            //                         {
            //                             "id": "163637245333116363724533310029"
            //                         },
            //                         {
            //                             "id": "163637241383216363724138320350"
            //                         },
            //                         {
            //                             "id": "163637245569016363724556904986"
            //                         }
            //                     ]
            //                 }
            //             ]
            //         },
            //         "status": "IN_CORRECT",
            //         "index": 0,
            //         "details": {
            //             "_id": "618910222f081330c715ff2d",
            //             "title": "",
            //             "displayTitle": "",
            //             "type": 5,
            //             "typeName": "ASSESSMENT QUESTION",
            //             "content": {
            //                 "type": 6,
            //                 "typeName": "GROUPING",
            //                 "title": "<p>Group the pairs as ‘In proportion’ and ‘Not in proportion’.</p>",
            //                 "images": [],
            //                 "complexityId": "5e71f8fe5c3254149568b8a8",
            //                 "duration": 2,
            //                 "mark": 3,
            //                 "solutionSteps": {
            //                     "type": "",
            //                     "typeName": "",
            //                     "question": [],
            //                     "steps": [],
            //                     "conclusion": "",
            //                     "summarySolution": "<ul><li>130 : 208 and 160 : 256</li></ul><p><cw-math data=\"130\\colon208=\\frac{130}{208}=\\frac{5 ×26}{8 ×26}=\\frac{5}{8}.\">130\\colon208=\\frac{130}{208}=\\frac{5 ×26}{8 ×26}=\\frac{5}{8}.</cw-math></p><p> </p><p><cw-math data=\"160\\colon256=\\frac{160}{256}=\\frac{5 ×32}{8 ×32}=\\frac{5}{8}.\">160\\colon256=\\frac{160}{256}=\\frac{5 ×32}{8 ×32}=\\frac{5}{8}.</cw-math></p><p> </p><p>Hence, the ratios 130 : 208 and 160 : 256 are in proportion.</p><p> </p><ul><li>84 : 56 and 129 : 86</li></ul><p><cw-math data=\"84\\colon56=\\frac{84}{56}=\\frac{3 ×28}{2 ×28}=\\frac{3}{2}.\">84\\colon56=\\frac{84}{56}=\\frac{3 ×28}{2 ×28}=\\frac{3}{2}.</cw-math></p><p> </p><p><cw-math data=\"129\\colon86=\\frac{129}{86}=\\frac{3 ×43}{2 ×43}=\\frac{3}{2}.\">129\\colon86=\\frac{129}{86}=\\frac{3 ×43}{2 ×43}=\\frac{3}{2}.</cw-math></p><p> </p><p>Hence, the ratios 84 : 56 and 129 : 86 are in proportion.</p><p> </p><ul><li>51 : 85 and 87 : 145</li></ul><p><cw-math data=\"51\\colon85=\\frac{51}{85}=\\frac{3 ×17}{5 ×17}=\\frac{3}{5}.\">51\\colon85=\\frac{51}{85}=\\frac{3 ×17}{5 ×17}=\\frac{3}{5}.</cw-math></p><p> </p><p><cw-math data=\"87\\colon145=\\frac{87}{145}=\\frac{3 ×29}{5 ×29}=\\frac{3}{5}.\">87\\colon145=\\frac{87}{145}=\\frac{3 ×29}{5 ×29}=\\frac{3}{5}.</cw-math></p><p> </p><p>Hence, the ratios 51 : 85 and 87 : 145 are in proportion.</p><p> </p><ul><li>42 : 63 and 28 : 70</li></ul><p><cw-math data=\"42\\colon63=\\frac{42}{63}=\\frac{2 ×21}{3 ×21}=\\frac{2}{3}\">42\\colon63=\\frac{42}{63}=\\frac{2 ×21}{3 ×21}=\\frac{2}{3}</cw-math></p><p> </p><p><cw-math data=\"28\\colon70=\\frac{28}{70}=\\frac{2 ×14}{5 ×14}=\\frac{2}{5}\">28\\colon70=\\frac{28}{70}=\\frac{2 ×14}{5 ×14}=\\frac{2}{5}</cw-math></p><p> </p><p>Both the ratios are in their lowest form and both are not equal.</p><p>Hence, the ratios 42 :  63 and 28 : 70 are not in proportion.</p><p> </p><ul><li>90 : 216 and 182 : 168</li></ul><p><cw-math data=\"90\\colon216=\\frac{90}{216}=\\frac{5 ×18}{12 ×18}=\\frac{5}{12}.\">90\\colon216=\\frac{90}{216}=\\frac{5 ×18}{12 ×18}=\\frac{5}{12}.</cw-math></p><p> </p><p><cw-math data=\"182\\colon168=\\frac{182}{168}=\\frac{13 ×14}{12 ×14}=\\frac{13}{12}.\">182\\colon168=\\frac{182}{168}=\\frac{13 ×14}{12 ×14}=\\frac{13}{12}.</cw-math></p><p> </p><p>Both the ratios are in their lowest form and both are not equal.</p><p>Hence, the ratios 90 : 216 and 182 : 168 are not in proportion.</p><p> </p><ul><li>55 : 60 and 31 : 155</li></ul><p><cw-math data=\"55\\colon60=\\frac{55}{60}=\\frac{11 ×5}{12 ×5}=\\frac{11}{12}.\">55\\colon60=\\frac{55}{60}=\\frac{11 ×5}{12 ×5}=\\frac{11}{12}.</cw-math></p><p> </p><p><cw-math data=\"31\\colon155=\\frac{31}{155}=\\frac{1 ×31}{5 ×31}=\\frac{1}{5}.\">31\\colon155=\\frac{31}{155}=\\frac{1 ×31}{5 ×31}=\\frac{1}{5}.</cw-math></p><p> </p><p>Both the ratios are in their lowest form and both are not equal.</p><p>Hence, the ratios 55 : 60 and 31 : 155 are not in proportion.</p>"
            //                 },
            //                 "options": [
            //                     {
            //                         "title": "<p>In proportion</p>",
            //                         "id": "163637238214916363723821493841",
            //                         "items": [
            //                             {
            //                                 "content": "<p>130 : 208 and 160 : 256</p>",
            //                                 "id": "163637240014016363724001402739",
            //                                 "contentType": 1,
            //                                 "contentTypeName": "TEXT"
            //                             },
            //                             {
            //                                 "content": "<p>84 : 56 and 129 : 86</p>",
            //                                 "id": "163637241383216363724138320350",
            //                                 "contentType": 1,
            //                                 "contentTypeName": "TEXT"
            //                             },
            //                             {
            //                                 "content": "<p>51 : 85 and 87 : 145</p>",
            //                                 "id": "163637241662816363724166281260",
            //                                 "contentType": 1,
            //                                 "contentTypeName": "TEXT"
            //                             }
            //                         ]
            //                     },
            //                     {
            //                         "title": "<p>Not in proportion</p>",
            //                         "id": "163637241971116363724197110745",
            //                         "items": [
            //                             {
            //                                 "content": "<p>42 : 63 and 28 : 70</p>",
            //                                 "id": "163637244568816363724456883169",
            //                                 "contentType": 1,
            //                                 "contentTypeName": "TEXT"
            //                             },
            //                             {
            //                                 "content": "<p>90 : 216 and 182 : 168</p>",
            //                                 "id": "163637245333116363724533310029",
            //                                 "contentType": 1,
            //                                 "contentTypeName": "TEXT"
            //                             },
            //                             {
            //                                 "content": "<p>55 : 60 and 31 : 155</p>",
            //                                 "id": "163637245569016363724556904986",
            //                                 "contentType": 1,
            //                                 "contentTypeName": "TEXT"
            //                             }
            //                         ]
            //                     }
            //                 ]
            //             },
            //             "notes": {
            //                 "error": "",
            //                 "success": ""
            //             },
            //             "createdDate": 1636372512699,
            //             "createdBy": "",
            //             "updatedDate": 1636374741019,
            //             "updatedBy": "",
            //             "state": "",
            //             "author": "",
            //             "parallel": [],
            //             "hint": "",
            //             "comprehension": [],
            //             "mandatoryAttachments": {
            //                 "audio": false,
            //                 "video": false,
            //                 "image": false
            //             },
            //             "countingwellCreatedTimestamp": "2021-11-08T11:55:14.682Z",
            //             "countingwellLastUpdateTimestamp": "2021-11-08T12:32:23.097Z",
            //             "id": "618910222f081330c715ff2d"
            //         }
            //     },
            //     {
            //         "id": "600a7e89062e1d316d54e241",
            //         "answer": {
            //             "id": "600a7e89062e1d316d54e241",
            //             "answer": [
            //                 {
            //                     "id": "161134909433716113490943370570",
            //                     "selected": [
            //                         {
            //                             "id": "161134914270916113491427095578"
            //                         },
            //                         {
            //                             "id": "161134912161216113491216122387"
            //                         },
            //                         {
            //                             "id": "161134915621916113491562194350"
            //                         }
            //                     ]
            //                 },
            //                 {
            //                     "id": "161134909595216113490959520820",
            //                     "selected": [
            //                         {
            //                             "id": "161134915054516113491505454377"
            //                         },
            //                         {
            //                             "id": "161134913269316113491326933853"
            //                         },
            //                         {
            //                             "id": "161134912649816113491264985851"
            //                         }
            //                     ]
            //                 }
            //             ]
            //         },
            //         "status": "IN_CORRECT",
            //         "index": 1,
            //         "details": {
            //             "_id": "600a7e89062e1d316d54e241",
            //             "title": "",
            //             "displayTitle": "",
            //             "type": 5,
            //             "typeName": "ASSESSMENT QUESTION",
            //             "content": {
            //                 "type": 6,
            //                 "typeName": "GROUPING",
            //                 "title": "<p>Group the given pair of figures as congruent and non-congruent.</p>",
            //                 "images": [],
            //                 "complexityId": "5e71f8fe5c3254149568b8a8",
            //                 "duration": 1,
            //                 "mark": 3,
            //                 "solutionSteps": {
            //                     "type": "",
            //                     "typeName": "",
            //                     "question": [],
            //                     "steps": [],
            //                     "conclusion": "",
            //                     "summarySolution": "<p>The figures having the same shape and size are called congruent figures.</p><p>Out of the given figures, the congruent figures are :<img alt=\"\" src=\"https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/4b0e9867-7a9e-48d9-9c53-598944899ea7-7%20NonCheckPoint%20Solution-01.png\" style=\"height:914px; width:801px\" /></p><p>The non-congruent figures are :<img alt=\"\" src=\"https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/bd47aab0-f91a-4e4a-8789-db60a2c73aaf-8%20NonCheckPoint%20Solution-01.png\" style=\"height:914px; width:801px\" /></p>"
            //                 },
            //                 "options": [
            //                     {
            //                         "title": "<p>Congruent</p>",
            //                         "id": "161134909433716113490943370570",
            //                         "items": [
            //                             {
            //                                 "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/302a758e-7382-41d2-ad95-717a490a24e1-6a%20CheckPoint%20Option-01.png",
            //                                 "id": "161134912161216113491216122387",
            //                                 "contentType": 2,
            //                                 "contentTypeName": "IMAGE"
            //                             },
            //                             {
            //                                 "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/b3fda8de-56db-49c3-b1c0-ec91f7f931fb-6b%20CheckPoint%20Option-01.png",
            //                                 "id": "161134912649816113491264985851",
            //                                 "contentType": 2,
            //                                 "contentTypeName": "IMAGE"
            //                             },
            //                             {
            //                                 "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/68284786-703e-4132-8bcf-1965052064f1-6c%20CheckPoint%20Option-01.png",
            //                                 "id": "161134913269316113491326933853",
            //                                 "contentType": 2,
            //                                 "contentTypeName": "IMAGE"
            //                             }
            //                         ]
            //                     },
            //                     {
            //                         "title": "<p>Non-Congruent</p>",
            //                         "id": "161134909595216113490959520820",
            //                         "items": [
            //                             {
            //                                 "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/0bb94f56-4563-41cc-a7ff-ac4e6e153798-6d%20CheckPoint%20Options-01.png",
            //                                 "id": "161134914270916113491427095578",
            //                                 "contentType": 2,
            //                                 "contentTypeName": "IMAGE"
            //                             },
            //                             {
            //                                 "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/3fd7784b-d7b8-42b1-9ad0-8d3cc84adb28-6e%20CheckPoint%20Option-01.png",
            //                                 "id": "161134915054516113491505454377",
            //                                 "contentType": 2,
            //                                 "contentTypeName": "IMAGE"
            //                             },
            //                             {
            //                                 "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/435426bd-7c60-45cc-9317-6f4f75139328-6f%20CheckPoint%20Option-01.png",
            //                                 "id": "161134915621916113491562194350",
            //                                 "contentType": 2,
            //                                 "contentTypeName": "IMAGE"
            //                             }
            //                         ]
            //                     }
            //                 ]
            //             },
            //             "notes": {
            //                 "error": "",
            //                 "success": ""
            //             },
            //             "createdDate": 1611349212087,
            //             "createdBy": "",
            //             "updatedDate": 1611349212087,
            //             "updatedBy": "",
            //             "state": "",
            //             "author": "",
            //             "parallel": [],
            //             "hint": "",
            //             "comprehension": [],
            //             "mandatoryAttachments": {
            //                 "audio": false,
            //                 "video": false,
            //                 "image": false
            //             },
            //             "countingwellLastUpdateTimestamp": "2021-01-22T07:28:09.939Z",
            //             "id": "600a7e89062e1d316d54e241"
            //         }
            //     },
            //     {
            //         "id": "6007e632062e1d316d54dd0e",
            //         "answer": {
            //             "id": "6007e632062e1d316d54dd0e",
            //             "answer": [
            //                 {
            //                     "id": "161113041762416111304176248138",
            //                     "selected": [
            //                         {
            //                             "id": "161113041762416111304176249409"
            //                         }
            //                     ]
            //                 },
            //                 {
            //                     "id": "161113041762416111304176245952",
            //                     "selected": [
            //                         {
            //                             "id": "161113041762416111304176248138"
            //                         }
            //                     ]
            //                 },
            //                 {
            //                     "id": "161113041762416111304176248662",
            //                     "selected": [
            //                         {
            //                             "id": "161113041762416111304176248662"
            //                         }
            //                     ]
            //                 },
            //                 {
            //                     "id": "161113041762416111304176249409",
            //                     "selected": [
            //                         {
            //                             "id": "161113041762416111304176245952"
            //                         }
            //                     ]
            //                 }
            //             ]
            //         },
            //         "status": "IN_CORRECT",
            //         "index": 2,
            //         "details": {
            //             "_id": "6007e632062e1d316d54dd0e",
            //             "title": "",
            //             "displayTitle": "",
            //             "type": 5,
            //             "typeName": "ASSESSMENT QUESTION",
            //             "content": {
            //                 "type": 4,
            //                 "typeName": "MATCHING",
            //                 "title": "<p>Match with the opposite of each of the following.</p>",
            //                 "images": [],
            //                 "complexityId": "5e8ebdf8d979fe12d6310080",
            //                 "duration": 1,
            //                 "mark": 1,
            //                 "solutionSteps": {
            //                     "type": "",
            //                     "typeName": "",
            //                     "question": [],
            //                     "steps": [],
            //                     "conclusion": "",
            //                     "summarySolution": "<p>The opposite of :</p><ul><li>Increase in 4 kg weight is decrease in 4 kg weight</li><li>4 km north is 4 km south</li><li>Loss of ₹400 is gain of ₹400</li><li>400 m above sea level is 400 m below sea level</li></ul>"
            //                 },
            //                 "options": [
            //                     {
            //                         "id": "161113041762416111304176248138",
            //                         "question": {
            //                             "content": "<p>Increase in 4 kg weight</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161113031973016111303197301431"
            //                         },
            //                         "answer": {
            //                             "content": "<p>Decrease in 4 kg weight</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161113031973016111303197306306"
            //                         }
            //                     },
            //                     {
            //                         "id": "161113041762416111304176245952",
            //                         "question": {
            //                             "content": "<p>4 km north</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161113033469816111303346989572"
            //                         },
            //                         "answer": {
            //                             "content": "<p>4 km south</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161113033469816111303346983529"
            //                         }
            //                     },
            //                     {
            //                         "id": "161113041762416111304176248662",
            //                         "question": {
            //                             "content": "<p>Loss of ₹400</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161113035295816111303529583650"
            //                         },
            //                         "answer": {
            //                             "content": "<p>Gain of ₹400</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161113035295816111303529585184"
            //                         }
            //                     },
            //                     {
            //                         "id": "161113041762416111304176249409",
            //                         "question": {
            //                             "content": "<p>400 m above sea level</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161113037203816111303720380803"
            //                         },
            //                         "answer": {
            //                             "content": "<p>400 m below sea level</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161113037203816111303720386583"
            //                         }
            //                     }
            //                 ]
            //             },
            //             "notes": {
            //                 "error": "",
            //                 "success": ""
            //             },
            //             "createdDate": 1611130417623,
            //             "createdBy": "",
            //             "updatedDate": 1611147234310,
            //             "updatedBy": "",
            //             "state": "",
            //             "author": "",
            //             "parallel": [],
            //             "hint": "",
            //             "comprehension": [],
            //             "mandatoryAttachments": {
            //                 "audio": false,
            //                 "video": false,
            //                 "image": false
            //             },
            //             "countingwellLastUpdateTimestamp": "2021-01-20T12:53:55.790Z",
            //             "id": "6007e632062e1d316d54dd0e"
            //         }
            //     },
            //     {
            //         "id": "6007e230062e1d316d54dcf6",
            //         "answer": {
            //             "id": "6007e230062e1d316d54dcf6",
            //             "answer": [
            //                 {
            //                     "id": "161117811453516111781145355175",
            //                     "selected": [
            //                         {
            //                             "id": "161117811453516111781145358367"
            //                         }
            //                     ]
            //                 },
            //                 {
            //                     "id": "161117811453516111781145353478",
            //                     "selected": [
            //                         {
            //                             "id": "161117811453516111781145353478"
            //                         }
            //                     ]
            //                 },
            //                 {
            //                     "id": "161117811453516111781145358367",
            //                     "selected": [
            //                         {
            //                             "id": "161117811453516111781145355077"
            //                         }
            //                     ]
            //                 },
            //                 {
            //                     "id": "161117811453516111781145355077",
            //                     "selected": [
            //                         {
            //                             "id": "161117811453516111781145355175"
            //                         }
            //                     ]
            //                 }
            //             ]
            //         },
            //         "status": "IN_CORRECT",
            //         "index": 3,
            //         "details": {
            //             "_id": "6007e230062e1d316d54dcf6",
            //             "title": "",
            //             "displayTitle": "",
            //             "type": 5,
            //             "typeName": "ASSESSMENT QUESTION",
            //             "content": {
            //                 "type": 4,
            //                 "typeName": "MATCHING",
            //                 "title": "<p>Match the type of angle represented by each figure.</p>",
            //                 "images": [],
            //                 "complexityId": "5e71f8fe5c3254149568b8a8",
            //                 "duration": 1,
            //                 "mark": 2,
            //                 "solutionSteps": {
            //                     "type": "",
            //                     "typeName": "",
            //                     "question": [],
            //                     "steps": [],
            //                     "conclusion": "",
            //                     "summarySolution": "<p>The correct match is as given below:</p><p><img alt=\"\" src=\"https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/e90c2550-40e5-40d8-95d7-04ce551de15f-4.png\" style=\"height:1206px; width:806px\" /></p>"
            //                 },
            //                 "options": [
            //                     {
            //                         "id": "161117811453516111781145355175",
            //                         "question": {
            //                             "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/570522c0-5629-4c84-9e4d-c93638f74abe-3a.png",
            //                             "contentType": 2,
            //                             "contentTypeName": "IMAGE",
            //                             "id": "161117804578516111780457853283"
            //                         },
            //                         "answer": {
            //                             "content": "<p>Acute angle</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161117804578516111780457859196"
            //                         }
            //                     },
            //                     {
            //                         "id": "161117811453516111781145353478",
            //                         "question": {
            //                             "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/9735f9c1-557b-48a6-8718-487374399e47-3b.png",
            //                             "contentType": 2,
            //                             "contentTypeName": "IMAGE",
            //                             "id": "161117805889616111780588962402"
            //                         },
            //                         "answer": {
            //                             "content": "<p>Right angle</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161117805889616111780588965593"
            //                         }
            //                     },
            //                     {
            //                         "id": "161117811453516111781145358367",
            //                         "question": {
            //                             "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/afe469a8-08b5-4aba-9565-9715a001e86c-3c.png",
            //                             "contentType": 2,
            //                             "contentTypeName": "IMAGE",
            //                             "id": "161117806018716111780601878313"
            //                         },
            //                         "answer": {
            //                             "content": "<p>Obtuse angle</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161117806018716111780601873355"
            //                         }
            //                     },
            //                     {
            //                         "id": "161117811453516111781145355077",
            //                         "question": {
            //                             "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/f0fcc7cd-cc1f-4386-9fca-1c593f1dcc4f-3d.png",
            //                             "contentType": 2,
            //                             "contentTypeName": "IMAGE",
            //                             "id": "161117806154316111780615432940"
            //                         },
            //                         "answer": {
            //                             "content": "<p>Straight angle</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "161117806154316111780615434524"
            //                         }
            //                     }
            //                 ]
            //             },
            //             "notes": {
            //                 "error": "",
            //                 "success": ""
            //             },
            //             "createdDate": 1611178114533,
            //             "createdBy": "",
            //             "updatedDate": 1611178114533,
            //             "updatedBy": "",
            //             "state": "",
            //             "author": "",
            //             "parallel": [],
            //             "hint": "",
            //             "comprehension": [],
            //             "mandatoryAttachments": {
            //                 "audio": false,
            //                 "video": false,
            //                 "image": false
            //             },
            //             "countingwellLastUpdateTimestamp": "2021-01-20T07:56:32.554Z",
            //             "id": "6007e230062e1d316d54dcf6"
            //         }
            //     },
            //     {
            //         "id": "5ff52a6c062e1d316d54cb90",
            //         "answer": {
            //             "id": "5ff52a6c062e1d316d54cb90",
            //             "answer": [
            //                 {
            //                     "id": "160995141471316099514147132986",
            //                     "selected": [
            //                         {
            //                             "id": "160995141471316099514147132986"
            //                         }
            //                     ]
            //                 },
            //                 {
            //                     "id": "160995141471316099514147135712",
            //                     "selected": [
            //                         {
            //                             "id": "160995141471316099514147138325"
            //                         }
            //                     ]
            //                 },
            //                 {
            //                     "id": "160995141471316099514147138325",
            //                     "selected": [
            //                         {
            //                             "id": "160995141471316099514147135712"
            //                         }
            //                     ]
            //                 }
            //             ]
            //         },
            //         "status": "IN_CORRECT",
            //         "index": 4,
            //         "details": {
            //             "_id": "5ff52a6c062e1d316d54cb90",
            //             "title": "",
            //             "displayTitle": "",
            //             "type": 5,
            //             "typeName": "ASSESSMENT QUESTION",
            //             "content": {
            //                 "type": 4,
            //                 "typeName": "MATCHING",
            //                 "title": "<p>Match the views of the given solid with its respective views.</p>",
            //                 "images": [
            //                     {
            //                         "imageUrl": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/114bd268-7ca4-4f13-976d-85377a495541-25.png"
            //                     }
            //                 ],
            //                 "complexityId": "5e71f8fe5c3254149568b8a8",
            //                 "duration": 1,
            //                 "mark": 3,
            //                 "solutionSteps": {
            //                     "type": "",
            //                     "typeName": "",
            //                     "question": [],
            //                     "steps": [],
            //                     "conclusion": "",
            //                     "summarySolution": "<p>Top, front and side views of the solid are given below.<img alt=\"\" src=\"https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/26d83db0-d62c-4c71-97be-264f3fe1ec4a-27.png\" style=\"height:252px; width:806px\" /></p>"
            //                 },
            //                 "options": [
            //                     {
            //                         "id": "160995141471316099514147132986",
            //                         "question": {
            //                             "content": "<p>Top view</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "160995126530916099512653099975"
            //                         },
            //                         "answer": {
            //                             "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/b0dc82a3-8471-48e8-af5b-0ac92b0d2bb1-26a.png",
            //                             "contentType": 2,
            //                             "contentTypeName": "IMAGE",
            //                             "id": "160995126530916099512653093996"
            //                         }
            //                     },
            //                     {
            //                         "id": "160995141471316099514147135712",
            //                         "question": {
            //                             "content": "<p>Side view</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "160995126640516099512664055935"
            //                         },
            //                         "answer": {
            //                             "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/7c7a866d-3ed3-48d9-bc34-50b6597c8978-26b.png",
            //                             "contentType": 2,
            //                             "contentTypeName": "IMAGE",
            //                             "id": "160995126640516099512664057967"
            //                         }
            //                     },
            //                     {
            //                         "id": "160995141471316099514147138325",
            //                         "question": {
            //                             "content": "<p>Front view</p>",
            //                             "contentType": 1,
            //                             "contentTypeName": "TEXT",
            //                             "id": "160995126931116099512693113799"
            //                         },
            //                         "answer": {
            //                             "content": "https://countingwell-assets-production.s3.ap-south-1.amazonaws.com/c5f55191-8dcb-4769-849c-642e56df8ec0-26c.png",
            //                             "contentType": 2,
            //                             "contentTypeName": "IMAGE",
            //                             "id": "160995126931116099512693119458"
            //                         }
            //                     }
            //                 ]
            //             },
            //             "notes": {
            //                 "error": "",
            //                 "success": ""
            //             },
            //             "createdDate": 1609951414713,
            //             "createdBy": "",
            //             "updatedDate": 1609911127419,
            //             "updatedBy": "",
            //             "state": "",
            //             "author": "",
            //             "parallel": [],
            //             "hint": "",
            //             "comprehension": [],
            //             "mandatoryAttachments": {
            //                 "audio": false,
            //                 "video": false,
            //                 "image": false
            //             },
            //             "countingwellLastUpdateTimestamp": "2021-01-06T05:32:07.947Z",
            //             "id": "5ff52a6c062e1d316d54cb90"
            //         }
            //     },
            //     {
            //         "id": "5fbf8c1462922d719cfbed0a",
            //         "answer": {
            //             "id": "5fbf8c1462922d719cfbed0a",
            //             "answer": [
            //                 {
            //                     "id": "160343706418916034370641897594"
            //                 },
            //                 {
            //                     "id": "160343708310616034370831063095"
            //                 },
            //                 {
            //                     "id": "160343707331316034370733137668"
            //                 },
            //                 {
            //                     "id": "160343700940416034370094048156"
            //                 }
            //             ]
            //         },
            //         "status": "IN_CORRECT",
            //         "index": 5,
            //         "details": {
            //             "_id": "5fbf8c1462922d719cfbed0a",
            //             "title": "Calculation - M2",
            //             "displayTitle": "",
            //             "type": 1,
            //             "typeName": "ASSESSMENT CONTENT",
            //             "content": {
            //                 "type": 5,
            //                 "typeName": "SEQUENCE",
            //                 "title": "<p>Arrange the given rational numbers in ascending order.</p>",
            //                 "images": [],
            //                 "solutionSteps": {
            //                     "type": "",
            //                     "typeName": "",
            //                     "question": [],
            //                     "steps": [],
            //                     "conclusion": "",
            //                     "summarySolution": "<p>The denominators of the given rational numbers are positive.</p><p> </p><p>The denominators are 3, 9, 3 and 9.</p><p> </p><p>Their LCM is 9.</p><p> </p><p>Writing the numbers so that they have a common denominator 9 as follows:</p><p> </p><p><cw-math data=\"\\frac{1}{3}=\\frac{1\\times3}{3\\times3}=\\frac{3}{9}\">\\frac{1}{3}=\\frac{1\\times3}{3\\times3}=\\frac{3}{9}</cw-math></p><p> </p><p><cw-math data=\"\\frac{2}{9}=\\frac{2\\times1}{9\\times1}=\\frac{2}{9}\">\\frac{2}{9}=\\frac{2\\times1}{9\\times1}=\\frac{2}{9}</cw-math></p><p> </p><p><cw-math data=\"\\frac{-1}{9}=\\frac{-1\\times1}{9\\times1}=\\frac{-1}{9}\">\\frac{-1}{9}=\\frac{-1\\times1}{9\\times1}=\\frac{-1}{9}</cw-math></p><p> </p><p><cw-math data=\"\\frac{-2}{3}=\\frac{-2\\times3}{3\\times3}=\\frac{-6}{9}\">\\frac{-2}{3}=\\frac{-2\\times3}{3\\times3}=\\frac{-6}{9}</cw-math></p><p> </p><p>Arranging the numerators of these rational numbers in ascending order, we get</p><p> </p><p><cw-math data=\"-6&lt;-1&lt;2&lt;3\">-6&lt;-1&lt;2&lt;3</cw-math></p><p> </p><p><cw-math data=\"\\frac{-6}{9}&lt;\\frac{-1}{9}&lt;\\frac{2}{9}&lt;\\frac{3}{9}\">\\frac{-6}{9}&lt;\\frac{-1}{9}&lt;\\frac{2}{9}&lt;\\frac{3}{9}</cw-math></p><p> </p><p><cw-math data=\"\\frac{-2}{3}&lt;\\frac{-1}{9}&lt;\\frac{2}{9}&lt;\\frac{1}{3}\">\\frac{-2}{3}&lt;\\frac{-1}{9}&lt;\\frac{2}{9}&lt;\\frac{1}{3}</cw-math></p><p> </p><p>Hence, the rational numbers in ascending order are as follows.</p><p> </p><p><cw-math data=\"\\frac{-2}{3},\\frac{-1}{9},\\frac{2}{9},\\frac{1}{3}\">\\frac{-2}{3},\\frac{-1}{9},\\frac{2}{9},\\frac{1}{3}</cw-math></p>"
            //                 },
            //                 "options": [
            //                     {
            //                         "id": "160343700940416034370094048156",
            //                         "contentType": 1,
            //                         "contentTypeName": "TEXT",
            //                         "content": "<p><cw-math data=\"\\frac{-2}{3}\">\\frac{-2}{3}</cw-math></p>",
            //                         "order": 1
            //                     },
            //                     {
            //                         "id": "160343706418916034370641897594",
            //                         "contentType": 1,
            //                         "contentTypeName": "TEXT",
            //                         "content": "<p><cw-math data=\"\\frac{-1}{9}\">\\frac{-1}{9}</cw-math></p>",
            //                         "order": 2
            //                     },
            //                     {
            //                         "id": "160343707331316034370733137668",
            //                         "contentType": 1,
            //                         "contentTypeName": "TEXT",
            //                         "content": "<p><cw-math data=\"\\frac{2}{9}\">\\frac{2}{9}</cw-math></p>",
            //                         "order": 3
            //                     },
            //                     {
            //                         "id": "160343708310616034370831063095",
            //                         "contentType": 1,
            //                         "contentTypeName": "TEXT",
            //                         "content": "<p><cw-math data=\"\\frac{1}{3}\">\\frac{1}{3}</cw-math></p>",
            //                         "order": 4
            //                     }
            //                 ]
            //             },
            //             "notes": {
            //                 "error": "",
            //                 "success": ""
            //             },
            //             "createdDate": 1601095212216,
            //             "createdBy": "",
            //             "updatedDate": 1619863345148,
            //             "updatedBy": "",
            //             "state": "",
            //             "author": "",
            //             "parallel": [],
            //             "hint": "<p>Find LCM of denominators and convert each rational number with this LCM as their denominator</p>",
            //             "comprehension": [],
            //             "mandatoryAttachments": {
            //                 "audio": false,
            //                 "video": false,
            //                 "image": false
            //             },
            //             "parallelTo": "5f6ec62fac7ec8040173113f",
            //             "countingwellLastUpdateTimestamp": "2021-05-01T10:02:26.059Z",
            //             "id": "5fbf8c1462922d719cfbed0a"
            //         }
            //     }
            // ].map((question, index) => {
            //     question.index = index;
            //     return question
            // })

            // this.questions = questions
            // let questionGroup = this.groupbyStatus(questions)
            // this.intialQuestionGroup = questionGroup;

            // this.setState({ allQuestions: questions, questionGroup })
            // this.getContents(questions);
            if (err) {
                return;
            }


        })
    }

    groupbyStatus = (questions) => {
        let questionGroup = { "ALL": questions }
        let groupKeys = ["ALL"];

        if (questions && questions.length) {

            for (let i = 0; i < questions.length; i++) {
                let question = questions[i]

                this.allQuestionsHash[question.id] = question;

                if (questionGroup[question.status]) {
                    questionGroup[question.status].push(question)

                } else {
                    questionGroup[question.status] = [question]
                    groupKeys.push(question.status);
                }
            }
        }

        for (let j = 0; j < groupKeys.length; j++) {
            let key = groupKeys[j];
            let groupQuestions = questionGroup[key];
            let totalRecords = groupQuestions.length
            let totalPages = Math.ceil(groupQuestions.length / 2);

            this.tabQuestionDetails[key] = {
                totalRecords,
                totalPages,
                currentPage: 0
            }
        }
        return questionGroup
    }

    toggleShadow = () => {
        this.setState({ showShadow: !this.state.showShadow })
    }

    getContents = (questions) => {
        let ids = [];

        for (let i = 0; i < questions.length; i++) {
            ids.push(questions[i].id)
        }

        let payload = { _id: ids }

        if (ids && ids.length) {

            if (this.state.questions && this.state.questions.length)
                this.toggleLoading(true)
            else
                this.toggleFullScreenLoading(true)

            AssessmentApi.getContentList(payload).then((res) => {

                if (res.response && res.response.length) {

                    let questionFetched = [];

                    let questionsHash = {}

                    for (let j = 0; j < res.response.length; j++) {
                        let question = res.response[j];
                        let qDetails = this.allQuestionsHash[question._id];

                        qDetails.details = question
                        qDetails.details.id = question._id
                        questionFetched.push(qDetails);

                    }

                    questionFetched = questionFetched.sort((a, b) => a.index - b.index)

                    for (let i = 0; i < questionFetched.length; i++) {
                        let question = questionFetched[i]
                        if (!questionsHash[question.status]) {
                            questionsHash[question.status] = [question]
                        } else {
                            questionsHash[question.status].push(question)
                        }

                        if (!questionsHash[this.state.selectedTab]) {
                            questionsHash[this.state.selectedTab] = [question]
                        } else {
                            questionsHash[this.state.selectedTab].push(question)
                        }

                    }

                    this.setState({ questionsHash: questionsHash, questions: questionsHash[this.state.selectedTab], fullScreenLoading: false })

                }
            }).catch(err => {
                if (err) {
                    if (this.state.loading)
                        this.toggleLoading(false)

                    if (this.state.fullScreenLoading)
                        this.toggleFullScreenLoading(false)
                    return;
                }
            })
        }
    }

    toggleLoading = (value, callback) => {
        this.setState({ loading: value }, () => {
            callback && callback()
        });
    }

    toggleFullScreenLoading = (value, callback) => {
        this.setState({ fullScreenLoading: value }, () => {
            callback && callback()
        })
    }

    onClose = () => {
        // if (this.fromAssess)
        if (this.meta.type && this.meta.type == 'EVENT' ||
            (this.meta && this.meta.from && this.meta.from == Constants.REFRESHER_COURSE) ||
            (this.meta && this.meta.from && this.meta.from == Constants.SCHOLARSHIP_MAY_9_2021) ||
            (this.meta && this.meta.from && this.meta.from == Constants.SCHOLARSHIP_EVENT) ||
            (this.meta && this.meta.from && this.meta.from == Constants.EVENT_BASELINE) ||
            (this.meta && this.meta.from && this.meta.from == Constants.REWARD_EVENT_BASELINE) ||
            (this.meta && this.meta.from && this.meta.from == Constants.REWARD_EVENT_FINAL) ||
            (this.meta && this.meta.from && this.meta.from == Constants.MPL_EVENT) ||
            (this.meta && this.meta.isExamPrepKit) ||
            (this.meta && this.meta.from && this.meta.from == Constants.TWO_STEP_EVENT_BASELINE) ||
            (this.meta && this.meta.from && this.meta.from == Constants.TWO_STEP_EVENT_FINAL) ||
            (this.meta && this.meta.from && this.meta.from == "HOMEWORK") ||
            (this.meta && this.meta.from && this.meta.from == "CLASSWORK") ||
            (this.meta && this.meta.from && this.meta.from == Constants.MOCK_TEST)) {
            this.props.delegate &&
                this.props.delegate.hideViewAnswersScreen
                && this.props.delegate.hideViewAnswersScreen(this.meta.fromClassworkList || this.meta.fromHomeworkList ? false : true)
            return;
        }

        if (this.meta && this.meta.from && this.meta.from == 'CASE STUDY') {
            this.hideViewScreen()
            return;
        }

        // if (this.meta.from && this.meta.from == 'TRIAL_MY_ASSESSMENT') {
        //     this.props.navigation.navigate('LandingScreen')
        //     return;
        // }

        // this.props.navigation.navigate('MyAssessments')
        // else
        //     this.props.navigation.navigate('MyAssessments')

        console.log(this.meta)

        this.props.hideViewAnswersScreen && this.props.hideViewAnswersScreen()
    }

    goToHomeScreen() {

        if (this.meta && this.meta.from && this.meta.from == Constants.REFRESHER_COURSE) {
            this.onClose()
        } else if (this.meta && this.meta.from == 'CASE STUDY') {
            this.props.delegate && this.props.delegate.goToHomeScreen && this.props.delegate.goToHomeScreen()
        } else {
            return this.props.delegate?.props.history.replace({ pathname: Path.HOME })
        }
    }

    goToPracticeQuestionsChapterList() {
        this.props.delegate && this.props.delegate.goToPracticeQuestionsChapterList && this.props.delegate.goToPracticeQuestionsChapterList()
    }

    goToPracticeList() {
        this.props.delegate && this.props.delegate.hidePracticeCaseStudyEndScreen && this.props.delegate.hidePracticeCaseStudyEndScreen()
        this.props.onSelectChapter && this.props.onSelectChapter({ key: this.chapterKey, title: this.chapterTitle })
    }

    goToEventList() {
        this.props.delegate && this.props.delegate.hideViewAnswersScreen && this.props.delegate.hideViewAnswersScreen(false)
    }

    goToMyClassworkList() {
        this.props.delegate && this.props.delegate.hideViewAnswersScreen && this.props.delegate.hideViewAnswersScreen(false)
    }

    hideViewScreen() {

        if (this.meta && this.meta.from === 'CLASS_MOCK_TEST') {

            return this.props.hideViewAnswersScreen && this.props.hideViewAnswersScreen()
        }

        // console.log('', this.meta)

        this.props.delegate && this.props.delegate.hideViewAnswersScreen && this.props.delegate.hideViewAnswersScreen()
    }


    scollEndReached = () => {

        let tabQuestionDetails = this.tabQuestionDetails[this.state.selectedTab]

        let currentPage = tabQuestionDetails.currentPage;
        let totalPages = tabQuestionDetails.totalPages;
        let totalRecords = tabQuestionDetails.totalRecords;

        //alert(currentPage <= totalPages)

        if (currentPage >= totalPages)
            return;

        currentPage = currentPage + 1;

        tabQuestionDetails.currentPage = currentPage;

        let questionsToFetch = [];
        if (currentPage >= 1) {

            let questions = this.intialQuestionGroup[this.state.selectedTab];

            let startIndex = currentPage * this.CONTENT_FETCH_LIMIT - this.CONTENT_FETCH_LIMIT;
            let endIndex = currentPage * this.CONTENT_FETCH_LIMIT;

            if (endIndex > totalRecords) {
                endIndex = totalRecords;
            }

            for (let i = startIndex; i < endIndex; i++) {
                let question = questions[i];
                questionsToFetch.push(question);
            }

            ////console.log("questionsToFetch******************", questionsToFetch, questions);


            this.getContents(questionsToFetch, this.state.selectedTab)
        }



    }

    readerHeaderTab() {
        let tabJsx = [];

        // console.log(this.state.questionGroup["PARTIALLY_CORRECT"])

        tabJsx.push(
            <>
                <div className={`col text-center answer-status-text border-top-left-radius p-3 ${this.state.selectedTab == "ALL" ? '' : ''}`}
                    style={{
                        backgroundColor: `${this.state.selectedTab === "ALL" ? this.theme[`themeColor`] : ''}`
                        , color: `${this.state.selectedTab === "ALL" ? '#FFFFFF' : ''}`
                    }}
                    onClick={() => this.onTabSwitch("ALL")} key={"ALL"}>
                    <div>
                        {"ALL: "}{this.state.questionGroup["ALL"].length}
                    </div>
                </div>
                {this.state.questionGroup["CORRECT"] && this.state.questionGroup["CORRECT"].length ? <span className="verticleLine"></span> : ""}
            </>

        )

        if (this.state.questionGroup["CORRECT"] && this.state.questionGroup["CORRECT"].length) {
            tabJsx.push(
                <>
                    <div className={`col text-center answer-status-text p-3 
                    ${this.state.selectedTab == "CORRECT" ? '' : ''}
                    ${this.state.questionGroup["PARTIALLY_CORRECT"] && this.state.questionGroup["PARTIALLY_CORRECT"].length ? "" : 'border-top-right-radius'}`}
                        style={{
                            backgroundColor: `${this.state.selectedTab === "CORRECT" ? this.theme[`themeColor`] : ''}`
                            , color: `${this.state.selectedTab === "CORRECT" ? '#FFFFFF' : ''}`
                        }}
                        onClick={() => this.onTabSwitch("CORRECT")} key={"CORRECT"}>
                        <div>
                            {"CORRECT: "}{this.state.questionGroup["CORRECT"].length}
                        </div>
                    </div>
                    {this.state.questionGroup["PARTIALLY_CORRECT"] && this.state.questionGroup["PARTIALLY_CORRECT"].length ? <span className="verticleLine"></span> : ""}
                </>
            )
        }

        if (this.state.questionGroup["PARTIALLY_CORRECT"] && this.state.questionGroup["PARTIALLY_CORRECT"].length) {
            tabJsx.push(
                <>
                    <div className={`col text-center answer-status-text p-3 
                    ${this.state.selectedTab == "PARTIALLY_CORRECT" ? '' : ''}
                    ${this.state.questionGroup["IN_CORRECT"] && this.state.questionGroup["IN_CORRECT"].length ? "" : 'border-top-right-radius'}`}
                        style={{
                            backgroundColor: `${this.state.selectedTab === "PARTIALLY_CORRECT" ? this.theme[`themeColor`] : ''}`
                            , color: `${this.state.selectedTab === "PARTIALLY_CORRECT" ? '#FFFFFF' : ''}`
                        }}
                        onClick={() => this.onTabSwitch("PARTIALLY_CORRECT")} key={"PARTIALLY_CORRECT"}>
                        <div>
                            {"PARTIALLY CORRECT: "}{this.state.questionGroup["PARTIALLY_CORRECT"].length}
                        </div>
                    </div>
                    {this.state.questionGroup["IN_CORRECT"] && this.state.questionGroup["IN_CORRECT"].length ? <span className="verticleLine"></span> : ""}
                </>
            )
        }

        if (this.state.questionGroup["IN_CORRECT"] && this.state.questionGroup["IN_CORRECT"].length) {
            tabJsx.push(
                <>
                    <div className={`col text-center answer-status-text p-3 
                ${this.state.selectedTab == "IN_CORRECT" ? '' : ''}
                ${this.state.questionGroup["NOT_ATTEMPTED"] && this.state.questionGroup["NOT_ATTEMPTED"].length ? "" : 'border-top-right-radius'}`}
                        style={{
                            backgroundColor: `${this.state.selectedTab === "IN_CORRECT" ? this.theme[`themeColor`] : ''}`
                            , color: `${this.state.selectedTab === "IN_CORRECT" ? '#FFFFFF' : ''}`
                        }}
                        onClick={() => this.onTabSwitch("IN_CORRECT")} key={"IN_CORRECT"}>
                        <div>
                            {"INCORRECT: "}{this.state.questionGroup["IN_CORRECT"].length}
                        </div>
                    </div>
                    {this.state.questionGroup["NOT_ATTEMPTED"] && this.state.questionGroup["NOT_ATTEMPTED"].length ? <span className="verticleLine"></span> : ""}
                </>

            )
        }

        if (this.state.questionGroup["NOT_ATTEMPTED"] && this.state.questionGroup["NOT_ATTEMPTED"].length) {
            tabJsx.push(
                <div className={`col text-center answer-status-text border-top-right-radius p-3 ${this.state.selectedTab == "NOT_ATTEMPTED" ? '' : ''}`}
                    style={{
                        backgroundColor: `${this.state.selectedTab === "NOT_ATTEMPTED" ? this.theme[`themeColor`] : ''}`
                        , color: `${this.state.selectedTab === "NOT_ATTEMPTED" ? '#FFFFFF' : ''}`
                    }}
                    onClick={() => this.onTabSwitch("NOT_ATTEMPTED")} key={"NOT_ATTEMPTED"}>
                    <div>
                        {"NOT ATTEMPTED: "}{this.state.questionGroup["NOT_ATTEMPTED"].length}
                    </div>
                </div>
            )

        }

        return tabJsx

    }

    getItemLayout = (data, index) => {
        return { length: 50, offset: 50 * index, index }
    }

    onClickPage = (index) => {
        let question = this.state.questions[index].details

        // if (index)
        //     this.scroll.scrollToOffset({ animated: true, offset: this.positionHash[question._id] - 150 });

        let id = question._id

        const element = document.getElementById(id);
        //console.log(id, element)
        element.scrollIntoView({ behavior: "instant", block: 'center' })


    }

    renderHeader() {

        return (
            <div>

                <div>
                    {/* <View style={Styles.headerContainer}>
                        <TouchableOpacity onPress={this.onClose} hitSlop={Styles.hitSlop}>
                            <View style={Styles.headerTouchPadding}>
                                <Image source={getImageSource(ImageConstants.CLOSE_LEARNING_POPUP)} />
                            </View>
                        </TouchableOpacity>
                    </View> */}
                    <div className="row row-max-width justify-content-start align-content-center mr-0 ml-0 mt-3">
                        {this.readerHeaderTab()}
                    </div>
                    {
                        this.state.isReload ?
                            <div>
                                <QuestionPagination questions={this.state.questionGroup[this.state.selectedTab]} onClickPage={this.onClickPage} categoryThemeId={this.categoryThemeId}></QuestionPagination>
                            </div>
                            :
                            <></>
                    }

                </div>

            </div >

        )
    }


    onTabSwitch(status) {

        // if (this.tabQuestionDetails[status] && this.tabQuestionDetails[status].currentPage == 0) {
        //     this.setState({ selectedTab: status }, () => { this.scollEndReached(status) })
        // } else {
        //     this.setState({ selectedTab: status, questions: this.state.renderQuestions[status] })
        // }

        this.setState({ selectedTab: status, questions: this.state.questionsHash[status], isReload: false }, () => {
            this.setState({ isReload: true })
        })

        // this.scroll.scrollToOffset({ animated: false, offset: 0 });
    }

    goToCompletedMockTestList() {
        this.props.delegate && this.props.delegate.showCompletedAssessments && this.props.delegate.showCompletedAssessments()
    }

    hideViewAnswer() {
        this.props.delegate && this.props.delegate.hideViewAnswer && this.props.delegate.hideViewAnswer()
    }

    hideMockTest() {

        if (this.props.delegate && this.props.delegate.hideMockTest) {
            this.props.delegate && this.props.delegate.hideMockTest && this.props.delegate.hideMockTest()
            return;
        }
    }

    goToHome() {

        if (this.props.delegate && this.props.delegate.goToHome) {
            this.props.delegate && this.props.delegate.goToHome && this.props.delegate.goToHome()
            return
        }

    }


    renderBreadcrumb = () => {
        console.log(this.meta.from)
        if (this.meta.type && this.meta.type == 'EVENT' ||
            (this.meta && this.meta.from && this.meta.from == Constants.REFRESHER_COURSE) ||
            (this.meta && this.meta.from && this.meta.from == Constants.SCHOLARSHIP_MAY_9_2021) ||
            (this.meta && this.meta.from && this.meta.from == Constants.SCHOLARSHIP_EVENT) ||
            (this.meta && this.meta.from && this.meta.from == Constants.EVENT_BASELINE) ||
            (this.meta && this.meta.from && this.meta.from == Constants.REWARD_EVENT_BASELINE) ||
            (this.meta && this.meta.from && this.meta.from == Constants.REWARD_EVENT_FINAL) ||
            (this.meta && this.meta.from && this.meta.from == Constants.MPL_EVENT) ||
            (this.meta && this.meta.isExamPrepKit) ||
            (this.meta && this.meta.from && this.meta.from == Constants.TWO_STEP_EVENT_BASELINE) ||
            (this.meta && this.meta.from && this.meta.from == Constants.TWO_STEP_EVENT_FINAL) ||
            (this.meta && this.meta.from && this.meta.from == Constants.MOCK_TEST)) {
            return (
                <div className='breadcrumb mt-2'>
                    <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()}>{`Home >`}</span>
                    {
                        this.meta && this.meta.from && this.meta.from == Constants.TWO_STEP_EVENT_FINAL ?
                            <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goToEventList()} >{`Events >`}</span>
                            :
                            <></>
                    }

                    {/* <span className='title-1 pl-2'>{`${this.meta.chapterTitle} >`}</span> */}
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.onClose()}>{`Assessment Completed`} {`>`}</span>
                    <span className='active pl-2'>{`View Answers`}</span>
                    {/* <span className='pl-2'>{this.props.selectedItem.chapters ? this.getChapterNames(this.selectedItem?.chapterName) : this.props.selectedItem.chapter} {`>`}</span>
                    <span className='active pl-2'>{this.getDate(this.selectedItem.createdDate)}</span> */}
                </div>
            )
        } else if (this.meta && this.meta.from && this.meta.from == "CLASSWORK") {
            //console.log('inside classwork')
            return (
                <div className='breadcrumb mt-2'>
                    <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()}>{`Home >`}</span>
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goToMyClassworkList()} >{`School Assignments >`}</span>
                    {/* <span className='title-1 pl-2'>{`${this.meta.chapterTitle} >`}</span> */}
                    {this.meta && this.meta.fromClassworkList ? <></> : <span className='title-1 pl-2 cursor-pointer' onClick={() => this.onClose()}>{`Assessment Completed`} {`>`}</span>}
                    <span className='active pl-2'>{`View Answers`}</span>
                    {/* <span className='pl-2'>{this.props.selectedItem.chapters ? this.getChapterNames(this.selectedItem?.chapterName) : this.props.selectedItem.chapter} {`>`}</span>
                    <span className='active pl-2'>{this.getDate(this.selectedItem.createdDate)}</span> */}
                </div>
            )
        } else if (this.meta && this.meta.from && this.meta.from == "HOMEWORK") {
            //console.log('inside homework')
            return (
                <div className='breadcrumb mt-2'>
                    <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()}>{`Home >`}</span>
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goToMyClassworkList()} >{`My Homework >`}</span>
                    {/* <span className='title-1 pl-2'>{`${this.meta.chapterTitle} >`}</span> */}
                    {this.meta && this.meta.fromHomeworkList ? <></> : <span className='title-1 pl-2 cursor-pointer' onClick={() => this.onClose()}>{`Assessment Completed`} {`>`}</span>}
                    <span className='active pl-2'>{`View Answers`}</span>
                    {/* <span className='pl-2'>{this.props.selectedItem.chapters ? this.getChapterNames(this.selectedItem?.chapterName) : this.props.selectedItem.chapter} {`>`}</span>
                    <span className='active pl-2'>{this.getDate(this.selectedItem.createdDate)}</span> */}
                </div>
            )
        } else if (this.meta && this.meta.from === 'CASE STUDY') {
            return (
                <div className='breadcrumb mt-2'>
                    <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()} >{`Home >`}</span>
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goToPracticeList()} >{`Practice`} {`>`}</span>
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goToPracticeList()}>{this.chapterTitle} {`>`}</span>
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.hideViewAnswer()}>{`Case Studies`} {`>`}</span>
                    <span className='pl-2'>{`View Answers`}</span>
                </div>
            )
        } else if (this.meta && this.meta.from === 'CLASS_MOCK_TEST') {
            return (
                <div className='breadcrumb mt-2'>
                    <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()} >{`Home >`}</span>
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.hideViewScreen()} >{`Maths Diagnostic Assessment`} {`>`}</span>
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.hideViewScreen()}>{`Assessment Completed`} {`>`}</span>
                    <span className='active pl-2' >{`View Answers`}</span>
                </div>
            )
        } else if (this.meta && this.meta.from === 'SCIENCE_CLASS_MOCK_TEST') {
            return (
                <div className='breadcrumb mt-2'>
                    <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()} >{`Home >`}</span>
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.hideViewScreen()} >{`Science Diagnostic Assessment`} {`>`}</span>
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.hideViewScreen()}>{`Assessment Completed`} {`>`}</span>
                    <span className='active pl-2' >{`View Answers`}</span>
                </div>
            )
        }
        else {
            return (
                <div className='breadcrumb mt-2'>
                    <span className="home cursor-pointer" onClick={() => { this.chapterTitle ? this.goToHome() : this.goToHomeScreen() }} >{`Home >`}</span>
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.chapterTitle ? this.hideMockTest() : this.onClose()} >{this.chapterTitle ? this.chapterTitle : 'Mock Test'} {`>`}</span>
                    <span className='title-1 pl-2 cursor-pointer' onClick={() => this.onClose()}>{`Assessment Completed`} {`>`}</span>
                    <span className='active pl-2' >{`View Answers`}</span>
                </div>
            )
        }
    }

    renderItem(item, index) {
        console.log(item)
        let status = item.status
        return (
            <div className="mt-3" id={item.details._id}>
                {/* <Text>{index}</Text> */}
                <div className=" question-info row align-items-center justify-content-start mr-0 mb-3" >
                    <div className="col-1 question-number-wrapper">
                        <div className="d-flex align-items-center justify-content-center">
                            <div className="question-number-text text-center" style={{ backgroundColor: this.theme[`themeColor`] }}>{item.index + 1}</div>
                        </div>
                    </div>
                    <div className="header-wrapper d-flex  align-items-center justify-content-start mt-1 col">
                        {status == "IN_CORRECT" ?
                            <div className="not-attempted-wrapper">
                                <span className="question-status-text  question-incorrect">
                                    {/* {"YOU GOT IT WRONG"} */}
                                    {"INCORRECT"}
                                </span>
                                <img className="tick-icon ml-2 mb-1" src={getImageSource(ImageConstants.INCORRECT_ANSWER_ICON)} />
                            </div>
                            :
                            status == "CORRECT" ?
                                <div className="not-attempted-wrapper">
                                    <span className="question-status-text question-correct">
                                        {/* {"YOU GOT IT RIGHT"} */}
                                        {"CORRECT"}
                                    </span>
                                    <img className="tick-icon ml-2 mb-1" src={getImageSource(ImageConstants.CORRECT_ANSWER_ICON)} />
                                </div>
                                :
                                status == 'PARTIALLY_CORRECT' ?
                                    <div className="not-attempted-wrapper">
                                        <span className="question-status-text question-correct">
                                            {/* {"YOU GOT IT RIGHT"} */}
                                            {"PARTIALLY CORRECT"}
                                        </span>
                                        <img className="tick-icon ml-2 mb-1" src={getImageSource(ImageConstants.CORRECT_ANSWER_ICON)} />
                                    </div>
                                    :
                                    <div className="not-attempted-wrapper">
                                        <span className="question-status-text question-not-attempted">
                                            {"NOT ATTEMPTED"}
                                        </span>
                                        <img className="flag-icon ml-2 mb-1" src={getImageSource(ImageConstants.FLAG_ICON)} />
                                    </div>
                        }
                    </div>
                    <div className="mark-container col-2 text-center mt-1">
                        <img className="exam-pad-icon" src={getImageSource(ImageConstants.EXAM_PAD_ICON_BLOCK)} />
                        <span className="marks">{status == "CORRECT" ? item.details.content.mark : status == 'PARTIALLY_CORRECT' ? item.markScored : 0}/{item.details.content.mark}</span>
                    </div>
                </div>

                <div className="question-scroll-wrapper">
                    <Question content={item.details} key={item.details._id} answer={item.answer} status={item.status} categoryThemeId={this.categoryThemeId} questionNumber={item.index + 1}>
                    </Question>

                    {item.details && item.details.content && !item.details.content.isMultiStep ? <AssessmentSolution content={item.details} categoryThemeId={this.categoryThemeId}></AssessmentSolution> : <></>}
                </div>
                {
                    index != this.state.questions.length - 1 ?
                        <div className="mt-3 d-flex justify-content-center">
                            <img className="content-separator-size" src={getImageSource(ImageConstants.LEARNING_CONTENT_SEPARATOR)} />
                        </div>
                        :
                        <></>
                }
                {
                    this.state.questions && this.state.questionGroup[this.state.selectedTab] && this.state.questionGroup[this.state.selectedTab].length == this.state.questions.length && index == this.state.questionGroup[this.state.selectedTab].length - 1 ?
                        <div className="d-flex justify-content-center mt-5 mb-5">
                            <div className="done-button cursor-pointer" onClick={this.onClose} style={{ backgroundColor: this.theme[`themeColor`], borderColor: this.theme[`themeColor`] }} >Done</div>
                        </div>
                        :
                        <></>
                }
            </div>
        )
    }


    render = () => {

        this.theme = SharedThemeCategory.getThemeCategory(this.categoryThemeId);

        //console.log(this.state.questions)


        return (

            !this.state.fullScreenLoading ?
                <div>
                    {
                        this.state.questions && this.state.questions.length ?
                            <div className="my-assessment-result">
                                <div className="text-right">
                                    <img className="image-size" src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_HEADER, this.categoryThemeId)}></img>
                                </div>
                                {
                                    this.renderBreadcrumb()
                                }
                                <div className="header-text mt-2">View Answers</div>
                                {
                                    this.state.questions && this.state.questions.length ?
                                        <>{this.renderHeader()}</>
                                        : <></>
                                }
                                <div>
                                    <img className="divider-image-width" src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_HEADER_DIVIDER, this.categoryThemeId)}></img>
                                </div>

                                {
                                    this.state.questions.map((item, index) => (
                                        this.renderItem(item, index)
                                    ))
                                }
                            </div>
                            :
                            <></>
                    }
                </div>
                :
                <Loading />
        )
    }


}

export default MyAssessmentResult